module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indentd"
  }, [_vm._v("“She was spreading herself like the night over the"), _c('br'), _vm._v("universe and found no god to lie with.”")]), _vm._v(" "), _c('p', {
    staticClass: "rightf"
  }, [_vm._v("Anaïs Nin")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01eab8ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_Front04.vue
// module id = 87
// module chunks = 0